import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import MatchmakingAuditForm from "./matchmaking-audit-form";
import MatchmakingAuditData from "./matchmaking-audit-data";

const KhattabatMatchmakingAudit = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "KHATTABAT_MATCHMAKING_AUDIT",
      "KHATTABAT_MATCHMAKING_AUDIT"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("MATCHMAKING_AUDIT")}
        subTitle={""}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <MatchmakingAuditForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <MatchmakingAuditData />
    </ET3PageDiv>
  );
});
export default KhattabatMatchmakingAudit;
